import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Image, Text, Flex } from 'atoms';
import goBack from 'assets/go-back-black.svg';
import { setShowLogout } from 'store/appSlice';

export default function Header() {
	const dispatch = useDispatch();

	const showModal = () => {
		dispatch(setShowLogout(true));
	};

	return (
		<Flex px="5px" justifyContent="space-around" alignItems="center" height="44px" color="#fff">
			<Box cursor="pointer" onClick={showModal}>
				<Image src={goBack} alt="Logout" />
			</Box>
			<Text fontSize="16px" lineHeight="19px" color="#007FFF">
				Sales Men
			</Text>
			<Box />
		</Flex>
	);
}
